<template>
<div style="min-height: 100vh">
<div class="section" :style="boxSettings" style="min-height: 100vh">
    <div class="columns">
        <div class="column is-one-third is-centered is-offset-one-third has-text-centered">
            <a class="center" :href="linkedinLink" target="_blank" > 
                <img :src="logo" height="auto" width="125px">
            </a>
        </div>
    </div>
    <div class="columns">
            <div class="column is-one-third is-centered is-offset-one-third has-text-centered">
                <span class="is-size-3" :style="h1Data"> Quiz LeaderBoard </span>   
            </div>
    </div>
    <div class="columns">
            <div class="column is-6 is-centered is-offset-3 has-text-centered" style="display: grid;">
    <label for="filter" placeholder="search"></label>
    <div style="align-self: end;">
        <input type="text" class="form-control is-pulled-right" v-model="filter" style="padding: 5px; margin-bottom: 5px;" placeholder="Search" @keydown="$event.stopImmediatePropagation()">
    </div>
    <br />
     <datatable ref="leaderboardCount" :columns="columns" class="table is-responsive" style="width: 100%" :data="user_array" :filter="filter" :per-page="10"></datatable>
     <datatable-pager v-model="page" type="abbreviated"></datatable-pager>

    </div>
    </div>
    <br />
     <div class="columns">
        <div class="column is-one-third is-centered is-offset-one-third has-text-centered">
            <a class="center" :href="linkedinLink" target="_blank" > 
                <img src="https://konfhub-image-files-prod.s3.ap-south-1.amazonaws.com/powered-by-konfhub-white.png" height="auto" width="220px">
            </a>
        </div>
        
    </div>
</div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
       return{
            filter:  '',
        columns: [
            { label: 'Rank', representedAs: (row) => {return parseInt(row.rank)}, align: 'center', sortable: false },
            { label: 'Name', field: 'name', align: 'center', sortable: false },
            { label: 'Correct Answers', field: 'correctOptionsCount', align: 'center', sortable: false },
            { label: 'Time Taken',  representedAs: (row) => (row.timeConsumed/1000000).toFixed(4) , align: 'center', sortable: false }
        ] ,
        page: 1,
       }
    },
   
    mounted(){
        this.$store.dispatch('leaderBoard', {
        eventId: this.$route.params.quiz,
        })
    },
    watch:{
        filter(newVal){
            if(newVal !== ''){
                this.page = 1
                this.$refs.leaderboardCount.page = 1
            }
        }
    },
    computed: {
    ...mapGetters(['user_array', 'logo', 'linkedinLink', 'backgroundColor', 'primaryColor', 'textColor']),
    boxSettings(){
      return{
        "background-color": this.backgroundColor,
      }
    },
    sumRef(){
        return{
            "border-color": this.primaryColor,
            "color":this.textColor
        }
    },
    tableContent(){
        return{
            "background-color": this.primaryColor,
            "color": this.textColor,
            "font-weight": bold,

        }
    },
    h1Data(){
        return{
            "color": this.primaryColor
        }
    },
  },
}
</script>

<style scoped>

</style>